import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
  Outlet,
} from "react-router-dom";
import { RouteErrorFallback } from "../components/RouteErrorFallback";
import { PlatformAdminPage } from "../pages/ops/PlatformAdminPage";
import { PlatformSheetPage } from "../pages/ops/PlatformSheetPage";

function OpsPortalShell() {
  return <Outlet />;
}

const opsRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<OpsPortalShell />} errorElement={<RouteErrorFallback />}>
      <Route index element={<Navigate to="/sheet" replace />} />
      <Route path="/sheet" element={<PlatformSheetPage />} />
      <Route path="/platform" element={<PlatformAdminPage />} />
      <Route path="/ops/sheet" element={<Navigate to="/sheet" replace />} />
      <Route path="/ops/platform" element={<Navigate to="/platform" replace />} />
      <Route path="/dashboard" element={<Navigate to="/sheet" replace />} />
      <Route path="/login" element={<Navigate to="/sheet" replace />} />
      <Route path="*" element={<Navigate to="/sheet" replace />} />
    </Route>
  ),
);

/** Operator portal — same build as ERP, different hostname (usr.godo-erp.com). */
export function OpsPortalRouter() {
  return <RouterProvider router={opsRouter} />;
}
